(() => {
  const root = document.getElementById('gpo-bfcm-promo');
  if (!root || window.GpoBfcmPromo) return;

  // Khớp config/promotions.php của app: mốc UTC, end không tính. Giá theo bảng giá hiện hành.
  const MONTHS = 3;
  const PLANS = [
    { name: 'Premium', price: 9.9 },
    { name: 'Advanced', price: 19.9 }
  ];
  const PHASES = [
    { id: 'early', name: 'Black Friday Early Bird', start: Date.UTC(2026, 9, 15), end: Date.UTC(2026, 10, 21), monthly: 50, yearly: 25, code: 'BFCM26EARLY' },
    { id: 'bfcm', name: 'Black Friday Sale', start: Date.UTC(2026, 10, 21), end: Date.UTC(2026, 11, 1), monthly: 25, yearly: 20, code: 'BFCM26' }
  ];

  // Trong theme editor xem trước bằng ?gpo_bfcm_preview=early|bfcm
  const preview = window.Shopify?.designMode ? new URLSearchParams(window.location.search).get('gpo_bfcm_preview') : null;
  const now = Date.now();
  const phase = PHASES.find((item) => item.id === preview) || PHASES.find((item) => now >= item.start && now < item.end);
  if (!phase) return;

  const locale = document.documentElement.lang || navigator.language || 'en';
  const endsAt = (() => {
    const options = { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' };
    try {
      return new Intl.DateTimeFormat(locale, options).format(phase.end - 60000);
    } catch (error) {
      return new Intl.DateTimeFormat('en', options).format(phase.end - 60000);
    }
  })();
  const money = (value) => '$' + (Math.round(value * 100) / 100).toFixed(2);

  const text = {
    name: phase.name,
    code: phase.code,
    percent: phase.monthly + '%',
    months: 'first ' + MONTHS + ' months',
    title: 'Get ' + phase.monthly + '% off your first ' + MONTHS + ' months',
    annual: 'Prefer yearly billing? Get ' + phase.yearly + '% off your first year.',
    end: endsAt
  };
  root.querySelectorAll('[data-gpo-promo]').forEach((element) => {
    element.textContent = text[element.dataset.gpoPromo] ?? '';
  });

  const plans = root.querySelector('[data-gpo-promo-plans]');
  PLANS.forEach((plan) => {
    const row = document.createElement('li');
    const name = document.createElement('span');
    const regular = document.createElement('s');
    const price = document.createElement('b');
    const unit = document.createElement('small');
    name.textContent = plan.name;
    regular.textContent = money(plan.price);
    price.textContent = money(plan.price * (1 - phase.monthly / 100));
    unit.textContent = '/mo';
    price.append(unit);
    row.append(name, regular, price);
    plans.append(row);
  });

  const trigger = root.querySelector('[data-gpo-promo-open]');
  const overlay = root.querySelector('[data-gpo-promo-overlay]');
  const panel = root.querySelector('[data-gpo-promo-panel]');
  let lastFocus = null;
  let pageOverflow = '';

  const open = () => {
    lastFocus = document.activeElement;
    pageOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    root.dataset.state = 'open';
    trigger.setAttribute('aria-expanded', 'true');
    panel.focus({ preventScroll: true });
  };
  const close = () => {
    document.documentElement.style.overflow = pageOverflow;
    root.dataset.state = 'closed';
    trigger.setAttribute('aria-expanded', 'false');
    (lastFocus && lastFocus !== document.body ? lastFocus : trigger).focus({ preventScroll: true });
  };

  trigger.addEventListener('click', open);
  root.querySelector('[data-gpo-promo-close]').addEventListener('click', close);
  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) close();
  });
  document.addEventListener('keydown', (event) => {
    if (root.dataset.state !== 'open') return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...panel.querySelectorAll('a[href], button:not([disabled])')];
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  root.dataset.phase = phase.id;
  root.dataset.state = 'closed';
  root.hidden = false;
  window.GpoBfcmPromo = Object.freeze({ phase: phase.id, open, close });
})();
